(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('ListMedicationRepository', [
        'AprimaRestangular',
        ListMedicationRepository
    ]);

    function ListMedicationRepository(
        AprimaRestangular
    ) {
        var service = {
            getList: getList
        };

        return service;

        function getList(listName, params, cache) {
            var listPromise = AprimaRestangular.get()
                .all('lists/medications/' + listName)
                .withHttpConfig({
                    cache: cache,
                })
                .getList(params);

            return listPromise;
        }
    }

})(window.angular);
